export const prodConfig = {
  oauth: "https://new.zlinkcrm.com/",
  // oauth: "http://localhost:4200/",
  api: "https://zlinkcrm.com/api-n/",
  // api: "http://localhost:3000/api-n/",
  oldApi: "https://zlinkcrm.com/api/",
  socket: "https://new.zlinkcrm.com/",
};
